export const ADMIN_UIDS = 
[
    "n5pA5jZrjUcl9jew8BppuL4niR93",
]